<template>
  <div>
    <h2>
      Item Configuration
    </h2>
    <el-form
      ref="form"
      :rules="rules"
      :model="item"
    >
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item
            label="Prefix Required "
            prop="config_itm_prefix_req"
          >
            <el-switch
              v-model="item.config_itm_prefix_req"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            label="Prefix Definition"
            prop="config_itm_prefix_def"
          >
            <el-input
              v-model="item.config_itm_prefix_def"
              type="number"
              placeholder="Prefix Definition"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item
            label="Min Definition"
            prop="config_itm_min_def"
          >
            <el-input
              v-model="item.config_itm_min_def"
              type="number"
              placeholder="Min Definition"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            label="Max Definition"
            prop="config_itm_max_def"
          >
            <el-input
              v-model="item.config_itm_max_def"
              type="number"
              placeholder="Max Definition"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item
            label="Item Rules"
            prop="item_rules"
          >
            <item-rules-grid v-model="item.item_rules" />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import ItemRulesGrid from './ItemRulesGrid.vue'

export default {
  components: {
    ItemRulesGrid
  },
  props: {
    item: {
      type: Object,
      default: null,
      required: true
    }
  },
  data () {
    return {
      rules: {
        config_itm_min_def: [
          { required: true, message: 'Min Definition is required.', trigger: ['blur'] }
        ],
        config_itm_max_def: [
          { required: true, message: 'Max Definition is required.', trigger: ['blur'] }
        ]
      }
    }
  },
  methods: {
  }
}
</script>
